'use client';

import { Text, VStack } from '@nettbureau/vibrant-ui';
import { useContext } from 'react';
import { ConfigContext } from '../provider/config-provider';
import { getTextAlignment } from '../theme';
import { CardTitle } from './CardTitle';

interface Props {
  title: string;
  href: string | null;
  subTitle: string | null;
  bodyLine1: string | null;
  bodyLine2: string | null;
}

export function CardContactDetails({
  href,
  title,
  subTitle,
  bodyLine1,
  bodyLine2,
}: Props) {
  const { cardTextAlignment } = useContext(ConfigContext);

  return (
    <VStack padding={{ y: 'xs' }} justify="start">
      <CardTitle href={href} title={title} />

      {subTitle && (
        <Text
          block
          data-featured-card-address
          align={getTextAlignment(cardTextAlignment)}
        >
          {subTitle}
        </Text>
      )}

      <VStack padding={{ y: 'md' }}>
        {bodyLine1 && (
          <Text
            block
            data-featured-card-address
            align={getTextAlignment(cardTextAlignment)}
          >
            {bodyLine1}
          </Text>
        )}

        {bodyLine2 && (
          <Text
            block
            data-featured-card-address
            align={getTextAlignment(cardTextAlignment)}
          >
            {bodyLine2}
          </Text>
        )}
      </VStack>
    </VStack>
  );
}
